import { Injectable } from '@angular/core';
import { RequestStateManagerService } from '@shared/services';
import { AuthRequestPACIMState } from '@shared/model';

@Injectable()
export class AuthRequestPacimStateManagerService extends RequestStateManagerService<AuthRequestPACIMState> {
  get defaultState(): AuthRequestPACIMState {
    return {
      orderingProvider: null,
      servicingFacility: null,
      authorization: null,
      diagnoses: null,
      documents: null,
      clinicalInformation: {},
    };
  }
}
